/* PricingTab.styles.ts generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["isCalculator"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _37 = "._1di6fqd3:active{background-color:var(--ds-background-neutral-subtle-pressed)}";
const _36 = "._irr31eg3:hover{background-color:var(--ds-background-neutral-subtle-hovered)}";
const _35 = "._1ygb4suz:focus-visible{outline:2px solid var(--ds-border-focused)}";
const _34 = "._n7zl7v06{border-bottom:1px solid var(--ds-border)}";
const _33 = "._4t3it9kd{height:72px}";
const _32 = "._zulp1eps{gap:var(--ds-space-100)}";
const _31 = "._1yt4xjmg{padding:var(--ds-space-200)}";
const _30 = "._o5721q9c{white-space:nowrap}";
const _29 = "._19itglyw{border:none}";
const _28 = "._2rkoidpf{border-radius:0}";
const _27 = "._1bahv2br{justify-content:start}";
const _26 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _25 = "._80omtlke{cursor:pointer}";
const _24 = "._bfhkipex{background-color:var(--ds-surface-overlay)}";
const _23 = "._vwz4zwfg{line-height:2pc}";
const _22 = "._1wyb1j6v{font-size:1rem}";
const _21 = "._k48pni7l{font-weight:600}";
const _20 = "._ect48q0o{font-family:Charlie Text}";
const _19 = "@media not all and (min-width:64rem){._na0i1bp4{flex-direction:column}._2osn1eps{gap:var(--ds-space-100)}}";
const _18 = "._vwz41k8s{line-height:1.5rem}";
const _17 = "._1yt4pxbi{padding:var(--ds-space-200,1pc)}";
const _16 = "._4cvr1h6o{align-items:center}";
const _15 = "._1bah1h6o{justify-content:center}";
const _14 = "._2lx2vrvc{flex-direction:row}";
const _13 = "._1e0c1txw{display:flex}";
const _12 = "._1yt45mqy{padding:var(--ds-space-300) 0}";
const _11 = "._1yt4y2m5{padding:var(--ds-space-800) 0}";
const _10 = "._18s813hs{margin:var(--ds-space-400) auto}";
const _9 = "._p12f4okr{max-width:55.625rem}";
const _8 = "._otyrpb5x{margin-bottom:var(--_1s1re0b)}";
const _7 = "._otyrhiv4{margin-bottom:var(--ds-space-400)}";
const _6 = "._19pkxjmg{margin-top:var(--ds-space-200)}";
const _5 = "._vwz41icn{line-height:var(--ds-font-lineHeight-300)}";
const _4 = "._19pkpxbi{margin-top:var(--ds-space-200,1pc)}";
const _3 = "._1wybljao{font-size:var(--ds-font-size-200,1rem)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { GridUtils } from '@atlassian/amkt-common';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _2 = "._1bsb1osq{width:100%}";
const _ = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
export const Section = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "section",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_otyrxy5q _1bsb1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Section.displayName = 'Section';
}
export const PVPSection = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "section",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3, _4, _, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq _1wybljao _19pkpxbi _otyrxy5q _vwz41icn", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PVPSection.displayName = 'PVPSection';
}
export const ServerEolMessageContainer = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkxjmg _otyrhiv4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ServerEolMessageContainer.displayName = 'ServerEolMessageContainer';
}
export const PricingDescription = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "p",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_1s1re0b": ix(GridUtils.GutterSpacing.Comfortable)
      }),
      ref: __cmplr,
      className: ax(["_otyrpb5x", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingDescription.displayName = 'PricingDescription';
}
export const PricingCalculatorErrorContainer = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  const {
      isCalculator
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _10, _11, _12]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_p12f4okr _18s813hs", __cmplp.isCalculator ? "_1yt4y2m5" : "_1yt45mqy", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingCalculatorErrorContainer.displayName = 'PricingCalculatorErrorContainer';
}
export const AdditionalPricingSection = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_13, _14, _15, _16, _17, _3, _18, _19]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o _1yt4pxbi _1wybljao _vwz41k8s _na0i1bp4 _2osn1eps", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AdditionalPricingSection.displayName = 'AdditionalPricingSection';
}
export const BackButton = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded8);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_13, _16, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _4cvr1h6o _ect48q0o _k48pni7l _1wyb1j6v _vwz4zwfg _bfhkipex _80omtlke _syaz1k3w _1bahv2br _2rkoidpf _19itglyw _o5721q9c _1yt4xjmg _zulp1eps _4t3it9kd _n7zl7v06 _1ygb4suz _irr31eg3 _1di6fqd3", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BackButton.displayName = 'BackButton';
}